import { Outlet } from "react-router-dom";

export default function CalendarLayout() {
    return (
        <Outlet />
    )
}